import { useLayoutEffect } from "react";
// import { enableBodyScroll, disableBodyScroll } from "body-scroll-lock";

export function useLockBodyScroll(elementId?: string) {
  useLayoutEffect(() => {
    // Get original body overflow
    const originalStyle = window.getComputedStyle(document.body).overflow;
    // Prevent scrolling on mount
    document.body.style.overflow = "hidden";
    // Re-enable scrolling when component unmounts
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, []); // Empty array ensures effect is only run on mount and unmount
}
// export function useLockBodyScroll(elementId: string) {
//   useEffect(() => {
//     const element = document.getElementById(elementId)!;
//     disableBodyScroll(element);
//     return () => {
//       enableBodyScroll(element);
//     };
//   }, []); // Empty array ensures effect is only run on mount and unmount
// }
